import React from "react";
import { Col, Row, Button, Modal } from "react-bootstrap";
import { Formik, Form } from "formik";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import * as Yup from "yup";
import { CircularProgress } from "@material-ui/core";
import { updateCurrencyAsync } from "../../redux";
import { Card, CardBody } from "../../../../../_metronic/_partials/controls";

const CurrencyEdit = ({ showEditTemplete, setShowEditTemplate }) => {
  const { selectedCurrency } = useSelector(
    (state) => state.currencyManagement,
    shallowEqual
  );

  const dispatch = useDispatch();
  //call after template data save to close model
  const redirectBack = () => {
    setShowEditTemplate(false);
  };
  //formik validation schema
  const currencySchema = Yup.object().shape({
    buyer_value: Yup.string()
      .required("Please enter buyer value")
      .max(15, "Buyer value must be no more than 15 digits in length")
      .matches(
        /^(?!0$)\d{1,15}(\.\d+)?$/,
        "Value must be a valid number and not 0"
      ),
    sale_value: Yup.string()
      .required("Please enter sale value")
      .max(15, "Sale value must be no more than 15 digits in length")
      .matches(
        /^(?!0$)\d{1,15}(\.\d+)?$/,
        "Value must be a valid number and not 0"
      ),
  });
  return (
    <>
      <Modal
        show={showEditTemplete}
        onHide={() => setShowEditTemplate(false)}
        centered
        className="def_modal delete_modal"
        enforceFocus={false}
      >
        <Modal.Header closeButton>
          <Modal.Title className="fn_s_18 color_blk f-w-700">
            Edit Currency
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            enableReinitialize
            initialValues={selectedCurrency}
            validationSchema={currencySchema}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              setSubmitting(true);
              dispatch(
                updateCurrencyAsync(
                  values,
                  setSubmitting,
                  resetForm,
                  redirectBack
                )
              );
            }}
          >
            {({
              values,
              errors,
              touched,
              isSubmitting,
              handleBlur,
              handleChange,
            }) => (
              <Row className="justify-content-center">
                <Col lg={12}>
                  <Card>
                    <CardBody>
                      <Form>
                        <div className="form-group">
                          <label className="form-label text-white font-size-12px inter-font font-weight-normal">
                            Title
                          </label>
                          <input
                            placeholder="Enter Title"
                            type="text"
                            name="title"
                            readOnly
                            className={
                              errors.title && touched.title
                                ? "form-control re_inputRouded is-invalid border-less-input"
                                : "form-control re_inputRouded border-less-input"
                            }
                            // onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.title}
                          />
                          {touched.title && errors.title ? (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">
                                {errors.title}
                              </div>
                            </div>
                          ) : null}
                        </div>
                        <div className="form-group">
                          <label className="form-label text-white font-size-12px inter-font font-weight-normal">
                            Buyer Value
                          </label>
                          <input
                            placeholder="Enter Buyer Value"
                            type="text"
                            name="buyer_value"
                            className={
                              errors.buyer_value && touched.buyer_value
                                ? "form-control re_inputRouded is-invalid border-less-input"
                                : "form-control re_inputRouded border-less-input"
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.buyer_value}
                          />
                          {touched.buyer_value && errors.buyer_value ? (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">
                                {errors.buyer_value}
                              </div>
                            </div>
                          ) : null}
                        </div>
                        <div className="form-group">
                          <label className="form-label text-white font-size-12px inter-font font-weight-normal">
                            Sale Value
                          </label>
                          <input
                            placeholder="Enter Sale Value"
                            type="text"
                            name="sale_value"
                            className={
                              errors.sale_value && touched.sale_value
                                ? "form-control re_inputRouded is-invalid border-less-input"
                                : "form-control re_inputRouded border-less-input"
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.sale_value}
                          />
                          {touched.sale_value && errors.sale_value ? (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">
                                {errors.sale_value}
                              </div>
                            </div>
                          ) : null}
                        </div>
                        {isSubmitting ? (
                          <div className="basic-verification-loader text-center">
                            <CircularProgress />
                          </div>
                        ) : (
                          <div className="text-center">
                            <Button
                              variant="blue"
                              className="px-5 defpddng  btn btn-blue spinnerBtn add-avtar-btn d-flex justify-content-center"
                              size="lg"
                              type="submit"
                            >
                              Update
                            </Button>
                          </div>
                        )}
                      </Form>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default CurrencyEdit;
